
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic15Static as ObiHydraulic15StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-15-static.js';
 
 
 

 
 export const ObiHydraulic15Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-15-static',
   elementClass: ObiHydraulic15StaticElement,
   events: {
     
   }
  });
 
 